/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description: 识别中状态组件 - 自定义骨架屏
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-07-25 16:37:44
 */
import React from 'react'
import { Typography, Skeleton } from 'antd'
import './RecognitionContentRecognizing.scss'
import '../index.scss'

/**
 * 识别中状态组件
 */
const RecognitionContentRecognizing: React.FC = React.memo(({}) => {
  return (
    <div className="custom-gradient-skeleton">
      <div className="recognizing-status">
        <div className="status-section">
          <Typography.Text strong className="status-title">
            识别到的隐患
          </Typography.Text>
          <div style={{ marginTop: '16px' }}>
            <Skeleton
              active
              title={false}
              paragraph={{
                rows: 3,
                width: ['456px', '100%', '255px']
              }}
            />
          </div>
        </div>

        <div className="status-section">
          <Typography.Text strong className="status-title">
            参考标准
          </Typography.Text>
          <div style={{ marginTop: '16px' }}>
            <Skeleton
              active
              title={false}
              paragraph={{
                rows: 3,
                width: ['456px', '100%', '255px']
              }}
            />
          </div>
        </div>

        <div className="status-section">
          <Typography.Text strong className="status-title">
            思考过程
          </Typography.Text>
          <div style={{ marginTop: '16px' }}>
            <Skeleton
              active
              title={false}
              paragraph={{
                rows: 3,
                width: ['456px', '100%', '255px']
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
})

export default RecognitionContentRecognizing
